import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { CreateFeedbackRequestDto } from "../generated/generatedTypes";

const createFeedback = async (payload: CreateFeedbackRequestDto): Promise<void> => {
  const response = await apiFetch("api/feedback", {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    let errorMessage = "피드백을 제출하지 못했습니다. 잠시 후 다시 시도해주세요.";
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorMessage;
    } catch (e) {
      // Ignore if error response is not JSON or empty
    }
    throw new Error(errorMessage);
  }
};

export function useCreateFeedback(): UseMutationResult<void, Error, CreateFeedbackRequestDto> {
  const queryClient = useQueryClient();
  return useMutation<void, Error, CreateFeedbackRequestDto>({
    mutationFn: createFeedback,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["event", variables.eventId] });
    },
  });
}
